module.exports = __webpack_public_path__ + "img/prize3.8f5a34a9.png";